import { memo } from 'react';

import Variant from '../Variant';
import styles from './StepWeight.module.css';

import type { VariantData } from '@Pages/PageQuizMattrasses/typings';
import type { HTMLAttributes, FC, MouseEvent } from 'react';

export interface StepWeightProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> {
  className?: string;
  variants: VariantData[];
  onSelect?: (e: MouseEvent, variant: VariantData) => void;
}

const StepWeight: FC<StepWeightProps> = (props) => {
  const { variants, onSelect, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className={styles.variantsWrapper}>
        {variants.map((variant) => (
          <Variant
            className={styles.variant}
            key={variant.id}
            variant={variant}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
};

export default memo(StepWeight);
